import { render, staticRenderFns } from "./AssignmentsSection.vue?vue&type=template&id=16566c7a&"
import script from "./AssignmentsSection.vue?vue&type=script&lang=js&"
export * from "./AssignmentsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16566c7a')) {
      api.createRecord('16566c7a', component.options)
    } else {
      api.reload('16566c7a', component.options)
    }
    module.hot.accept("./AssignmentsSection.vue?vue&type=template&id=16566c7a&", function () {
      api.rerender('16566c7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/sections/AssignmentsSection.vue"
export default component.exports